import image_1 from './assets/itemImage_1.webp';
import image_2 from './assets/itemImage_2.webp';
import image_3 from './assets/itemImage_3.webp';
import image_4 from './assets/itemImage_4.webp';
import image_5 from './assets/itemImage_5.webp';
import image_6 from './assets/itemImage_6.webp';
import image_7 from './assets/itemImage_7.webp';
import image_8 from './assets/itemImage_8.webp';
import image_9 from './assets/itemImage_9.webp';
import image_10 from './assets/itemImage_10.webp';
import image_11 from './assets/itemImage_11.webp';
import image_12 from './assets/itemImage_12.webp';
export const RESTAURANT_MENU_DATA = [
    {
        id:1,
        itemName:'Gulab Jamun Per Pc',
        image:{image_1},
        price:'30',
    },
    {
        id:2,
        itemName:'Mutton Stew 1 Plate',
        image:{image_2},
        price:'400',
    },
    {
        id:3,
        itemName:'Chicken Dum Biryani',
        image:{image_3},
        price:'380',
    },
    {
        id:4,
        itemName:'Kolkata Chicken Biryani',
        image:{image_4},
        price:'420',
    },
    {
        id:5,
        itemName:'Chocolate Lava Cake',
        image:{image_5},
        price:'120',
    },
    {
        id:6,
        itemName:'Peri Peri Chicken 10 Leg Pc & 4 Dips',
        image:{image_6},
        price:'550',
    },
    {
        id:7,
        itemName:'Chicken Krisper Burger Combo',
        image:{image_7},
        price:'460',
    },
    {
        id:8,
        itemName:'Crispy Chilli Lamb',
        image:{image_8},
        price:'400',
    },
    {
        id:9,
        itemName:'Chicken Shanghai Bowl',
        image:{image_9},
        price:'360',
    },
    {
        id:10,
        itemName:'Chicken Korma Special',
        image:{image_10},
        price:'440',
    },
    {
        id:11,
        itemName:'Murgh Tandoori Half',
        image:{image_11},
        price:'260',
    },
    {
        id:12,
        itemName:'BHUNA MURGH WITH BONE',
        image:{image_12},
        price:'620',
    },
];
